import {Component, Inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Product} from '../../models/product';
import {SelectedItem} from '../../../order/models/order';
import {FormGroup, Validators} from '@angular/forms';
import {GroupConfig} from '../../models/config';
import {CommonField} from '../../models/common-field';
import {GetFormsService} from '../../services/get-forms.service';
import {GetConfigSharedService} from '../../services/get-config-shared.service';
import {ActivatedRoute, Router} from '@angular/router';
import {BsModalRef, BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {select, Store} from '@ngrx/store';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import * as fromShared from '../../reducers';
import * as moment from 'moment';
import * as _ from 'lodash';
import {SendBackResultCode} from '../..';
import {ReturnPlayerService} from '../../services/return-player.service';
import {UpdateLinkContractAction} from '../../actions/link-contract-update';
import {ReturnPlayerUpdateStatusAction} from '../../actions/anomaly-player-return';


@Component({
  selector: 'storever-anomaly-player-return',
  templateUrl: './anomaly-player-return.component.html',
  styleUrls: ['./anomaly-player-return.component.scss']
})
export class AnomalyPlayerReturnComponent implements OnInit, OnDestroy {
  @ViewChild('staticModal', {static: false}) public staticModal: ModalDirective;
  private sub$: Subscription;
  private subscriptions = [];
  selectedItem$: Observable<SelectedItem[]>;
  selectedOneItem$: Observable<SelectedItem>;
  // tslint:disable-next-line:no-any
  selectedItem: any[];
  // tslint:disable-next-line:no-any
  selectedOneItem: any;
  // tslint:disable-next-line:no-any
  @Input() productID: any;
  myForm: FormGroup;
  formSoldOrLost: FormGroup;
  formConfig: GroupConfig;
  formConfigSoldOrLost: GroupConfig;
  showHideReason = false;
  error = 'false';
  isBillingLinked: boolean;
  // tslint:disable-next-line:no-any
  selectedSub: any [] = [];
  product$: Observable<Product[]>;
  subscriptionsUuidList: string[];

  constructor(private getFormsService: GetFormsService,
              private getConfigSharedService: GetConfigSharedService,
              private returnPlayerService: ReturnPlayerService,
              private activatedRoute: ActivatedRoute,
              private bsModalRef: BsModalRef,
              private bsModalRefConfirmation: BsModalRef,
              private modalService: BsModalService,
              private router: Router,
              @Inject(L10N_LOCALE) public locale: L10nLocale,
              private store: Store<fromShared.AppState>) {
  }

  ngOnInit(): void {
    this.getSelectItemsInfo();
    this.formConfig = this.getConfigSharedService.getReturnPlayers();
    this.myForm = this.getFormsService.getReturnPlayers();

    this.formSoldOrLost = this.getFormsService.getRemovePlayerLostOrSold()
    this.formConfigSoldOrLost = this.getConfigSharedService.getConfigRemovePlayerLostOrSold();
    this.sub$ = this.myForm.get('playerLost').valueChanges.pipe(
    ).subscribe(value => {
      if (!value) {
        this.formSoldOrLost.get('reason').clearValidators();
        this.formSoldOrLost.get('reason').updateValueAndValidity();
      } else {
        this.formSoldOrLost.get('reason').setValidators([Validators.required]);
        this.formSoldOrLost.get('reason').updateValueAndValidity();
      }
    });
    this.subscriptions.push(this.sub$);
  }

  // tslint:disable-next-line:no-any
  send(value: any): void {
    this.store.dispatch(new ReturnPlayerUpdateStatusAction({
      'subscriptions': this.selectedSub,
      'comment': this.myForm.get('comment').value,
      'playerLost': this.myForm.get('playerLost').value,
      'reason': this.formSoldOrLost.get('reason').value }));

    this.close();
  }

  open(): void {
    this.staticModal.show();
  }

  close(): void {
    this.myForm.reset();
    this.formSoldOrLost.reset();
    this.selectedSub = [];
    this.bsModalRef.hide();
  }

  remove(index: number): void {
    if (index > -1) {
      this.selectedSub.splice(index, 1);
    }
  }

  removeSubscription(index: number): void {
    if (this.selectedItem.length > 1) {
      let selectedItemTemp;
      selectedItemTemp = _.cloneDeep(this.selectedItem);
      if (index > -1) {
        selectedItemTemp.splice(index, 1);
      }
      this.selectedItem = selectedItemTemp;
      this.selectedSub = selectedItemTemp;
    }
  }

  closeBSF(): void {
    this.selectedSub = [];
    this.bsModalRef.hide();
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }

  getSelectItemsInfo(): void {
    this.subscriptionsUuidList = [];
    this.selectedItem$ = this.store.pipe(select(fromShared.selectors.getSelectedSubList));
    // tslint:disable-next-line:no-any
    this.sub$ = this.selectedItem$.subscribe((data: any[]) => {
      if (data) {
        this.selectedItem = data;
        for (let j = 0; j < this.selectedItem.length; j++) {
          this.selectedSub.push({name: this.selectedItem[j].name , uuid: this.selectedItem[j].uuid  , clientUuid: this.selectedItem[j].clientUuid  });
          this.subscriptionsUuidList.push(this.selectedItem[j].uuid);
        }
      }

    });
    this.subscriptions.push(this.sub$);
    this.selectedOneItem$ = this.store.pipe(select(fromShared.selectors.getSelectedOneSubscription));
    // tslint:disable-next-line:no-any
    this.sub$ = this.selectedOneItem$.subscribe((data: any) => {
      if (data) {
        this.selectedOneItem = data;
        this.selectedSub.push({name: data.name , uuid: data.uuid  , clientUuid: data.clientUuid});
        this.subscriptionsUuidList.push(data.uuid);
      }

    });
    this.subscriptions.push(this.sub$);

    this.returnPlayerService.loadSummary({ 'subscriptions': this.subscriptionsUuidList}).subscribe(data => {
      if (data.statusCode === SendBackResultCode.Success && data.data && data.data.array && data.data.array.length > 0) {
        const arrayData = data.data.array;
        for (let i = 0; i < arrayData.length; i++) {
          if (this.selectedOneItem) {
            this.selectedOneItem = { ...this.selectedOneItem , deviceId: arrayData[i].deviceId};
            // tslint:disable-next-line:typedef
            this.selectedSub = _.map(this.selectedSub , function(item) {
              return item.uuid === arrayData[i].uuid ? { ...item, deviceId: arrayData[i].deviceId} : item;
            });
          } else {
            // tslint:disable-next-line:typedef
            this.selectedItem  = _.map(this.selectedItem , function(item) {
              return item.uuid === arrayData[i].uuid ? { ...item, deviceId: arrayData[i].deviceId} : item;
            });
            // tslint:disable-next-line:typedef
            this.selectedSub = _.map(this.selectedSub , function(item) {
              return item.uuid === arrayData[i].uuid ? { ...item, deviceId: arrayData[i].deviceId} : item;
            });
          }

        }
      }
    });
  }

}
